<template>
  <div class="allContent">
    <div class="game_title">
      <img
        :src="
          `https://oss.zhekoushenqi.com/data/homegameActivity/test1.png?t=${state.nowDay}`
        "
        alt=""
      />
      <div>
        <img
          :src="
            `https://oss.zhekoushenqi.com/data/homegameActivity/icon_dowland.png?t=${state.nowDay}`
          "
          alt=""
          @click="goGamedetails"
        />
      </div>
    </div>

    <!-- 活动抽奖 -->
    <activityLottery
      :lotteryNum="state.lotteryNum"
      :token="state.token"
      :nowDay="state.nowDay"
      :lotteryList="state.lotteryList"
      @getActivity="getActivity"
    />

    <!-- 任务信息 -->
    <taskInfo
      :video_url="state.gameVideo"
      :poster="state.gamePoster"
      :isLogin="state.isLogin"
      :isPay="state.isPay"
      :otherLog="state.otherLog"
      :gameName="state.gameName"
      :activityStatus="state.activityStatus"
      :gid="state.gid"
      :nowDay="state.nowDay"
    />

    <!-- 游戏信息 -->
    <gameinfoSwiper :swiperList="state.gamePhoto" :nowDay="state.nowDay" />
    <!-- 活动信息 -->
    <div class="activity_info">
      <activityInfo
        :myLog="state.myLog"
        :nowDay="state.nowDay"
        :activeTime="state.activeTime"
        :guize="state.guize"
      />
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, reactive, nextTick, onActivated } from "vue";

// 拆分组件
import activityInfo from "./homeGame/activityInfo";
import activityLottery from "./homeGame/activityLottery";
import taskInfo from "./homeGame/taskInfo.vue";
import gameinfoSwiper from "./homeGame/gameinfoSwiper.vue";
import lottery from "./lottery.vue";

import { detect } from "@/utils/device";
import { getQueryString } from "@/utils/location";

import { getactivityInfo } from "@/api/activity";
import { Toast } from "vant";
import { setToken, getToken } from "@/utils/auth";

const state = reactive({
  gid: "",
  token: "",
  activityInfo: {},
  lotteryList: [],
  gamePhoto: [],
  gameVideo: "",
  gamePoster: "",
  lotteryNum: 0,
  isLogin: 0,
  isPay: 0,
  otherLog: [],
  gameName: "",
  token: "",
  activityStatus: 0,
  // 今儿的日期
  nowDay: "",
  activeTime: "",
  guize: "",
});

onMounted(() => {
  // 设置token
  if (getQueryString("token") != "undefined") {
    setToken(getQueryString("token"));
    state.token = getQueryString("token");
  } else {
    setToken(route.query.token);
    state.token = route.query.token;
  }
  // 初始化获取活动信息
  getActivity();
});
onActivated(() => {
  state.nowDay = getCurrentTimestamp();
  // console.log("onActivated日期-----------", state.nowDay);
});

// 获取活动信息
const getActivity = () => {
  getactivityInfo({
    token: state.token,
  }).then((res) => {
    console.log("获取到的活动信息-----------", res.data.data);
    state.activityInfo = res.data.data;
    state.lotteryList = res.data.data.lotterylists;
    state.gamePhoto = res.data.data.photo;
    state.gameVideo = res.data.data.videourl;
    state.gamePoster = res.data.data.videoimg;
    state.lotteryNum = res.data.data.cjcs;
    state.isLogin = res.data.data.isLogin;
    state.isPay = res.data.data.isPay;
    state.otherLog = res.data.data.lottery_log_other;
    state.gameName = res.data.data.gamename;
    state.myLog = res.data.data.lottery_log;
    state.gid = res.data.data.gid;
    state.activityStatus = res.data.data.status;
    state.activeTime = res.data.data.time;
    state.guize = res.data.data.guize;
    // if (res.data.code == 1) {
    //   state.activityInfo = res.data.data;
    //   state.lotteryList = res.data.data.lotterylists;
    //   state.gamePhoto = res.data.data.photo;
    //   state.gameVideo = res.data.data.videourl;
    //   state.gamePoster = res.data.data.videoimg;
    //   state.lotteryNum = res.data.data.cjcs;
    //   state.isLogin = res.data.data.isLogin;
    //   state.isPay = res.data.data.isPay;
    //   state.otherLog = res.data.data.lottery_log_other;
    //   state.gameName = res.data.data.gamename;
    //   state.myLog = res.data.data.lottery_log;
    //   state.gid = res.data.data.gid;
    //   state.activityStatus = res.data.data.status;
    //   state.activeTime = res.data.data.time;
    // } else {
    //   Toast(res.data.msg);
    // }
  });
};

// 跳转到游戏详情页
const goGamedetails = () => {
  if(!state.gid){
    return
  }

  if (detect() == "android" || detect() == "harmony") {
    window.document.location = "gogame://" + state.gid;
  } else {
    var eventData = {
      eventType: "openEvent",
      gid: state.gid,
    };
    window.parent.postMessage(eventData, "*");
  }
  // console.log("跳转到游戏详情页--------",state.gid);
};

const getCurrentTimestamp = () => {
  return `${new Date().getMonth() +
    1}-${new Date().getDate()}-${new Date().getHours()}-${new Date().getMinutes()}`;
};
</script>
<style scoped>
.allContent {
  height: 100vh;
  overflow: auto;
  overflow-x: hidden;
  /* padding-bottom:100px; */
}
.allContent .game_title {
  height: 915px;
  width: 100%;
}
.game_title div {
  color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
}
.game_title div img {
  width: 357px;
  height: 160px;
}
img {
  height: 100%;
  width: 100%;
  vertical-align: bottom;
}

/* 活动信息 */
.activity_info {
  position: fixed;
  right: 0;
  bottom: 55%;
  z-index: 99;
}
.activity_info :deep(.van-popup) {
  background-color: rgba(0, 0, 0, 0);
}
.activity_info :deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.7);
}
.activity_info :deep(.van-checkbox__icon .van-icon) {
  border: 1px solid #fff;
}
</style>
